import React from 'react';
import PropTypes from 'prop-types';

import chevron from '../../../../assets/images/promos/chevron.svg';

const Promo = props => (
  <div>
    {!props.isExpanded && <button
      className="c-btn c-btn-promo"
      onClick={props.expandPromo}
    >
      {props.title}
      <img src={chevron} alt="Expand Promotion" />
    </button>}
    {props.isExpanded && props.component}
  </div>
);

Promo.propTypes = {
  title: PropTypes.string,
  component: PropTypes.oneOf([PropTypes.string, PropTypes.func]).isRequired,
  isExpanded: PropTypes.bool.isRequired,
  expandPromo: PropTypes.func.isRequired,
};

Promo.defaultProps = {
  title: 'Promotion Available',
  component: 'Error loading promotion details',
};

export default Promo;



// WEBPACK FOOTER //
// ./src/app/reservation/components/Promo.jsx